import React, { useState, VFC } from 'react'
import DateTimePicker, { registerLocale } from 'react-datepicker'
import ja from 'date-fns/locale/ja'
registerLocale('ja', ja)
import 'react-datepicker/dist/react-datepicker.css'
import { setHours, setMinutes, format, parseISO, getUnixTime } from 'date-fns'

type DatePickerProps = {
  selectedDate: string
  startDate: string
  endDate: string
  openTime: string
  closeTime: string
  idName: string
  nameName: string
  className: string
  clearable: boolean
  inputRef: React.Ref<HTMLInputElement>
  setDate: (date: string) => void
}

const DatePicker: VFC<DatePickerProps> = (props) => {
  const FORMAT = 'yyyy-MM-dd HH:mm'
  const [selectedDate, setSelectedDate] = useState(props.selectedDate ? parseISO(props.selectedDate) : null)
  const isClearableFlag = props.clearable

  // 開催日を判定
  const isDatePeriod = (date) => {
    const today = getUnixTime(new Date())
    const targetDate = getUnixTime(date)
    const startDate = getUnixTime(new Date(props.startDate))
    const endDate = getUnixTime(new Date(props.endDate))
    return startDate <= targetDate && targetDate <= endDate && today <= targetDate
  }

  // 開催時間を作成
  const createTimePeriod = (time) => {
    const splitTime = time.split(':')
    const hour = Number(splitTime[0])
    const minute = Number(splitTime[1])
    return setHours(setMinutes(new Date(), minute), hour)
  }

  interface InputProps {
    idName: string
    nameName: string
    className: string
    inputRef: React.Ref<HTMLInputElement>
    onClick?: React.MouseEventHandler<HTMLInputElement>
    onChange?: React.ChangeEventHandler<HTMLInputElement>
    value?: string | ReadonlyArray<string> | number
  }

  const Input = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => {
    return (
      <input
        type="text"
        id={props.idName}
        name={props.nameName}
        className={props.className}
        value={selectedDate != null ? format(selectedDate, FORMAT) : ''}
        onClick={props.onClick}
        onChange={props.onChange}
        readOnly
      />
    )
  })

  const handleColor = (time) => {
    const openTime = Number(format(new Date(props.openTime), 'HHmm'))
    const closeTime = Number(format(new Date(props.closeTime), 'HHmm'))
    const targetTime = Number(format(new Date(time), 'HHmm'))
    return openTime <= targetTime && targetTime <= closeTime ? '' : 'hide'
  }

  const selectDate = (date) => {
    setSelectedDate(date)
    props.setDate(date)
  }

  const tomorrow = () => {
    const dt = new Date()
    dt.setDate(dt.getDate() + 1)
    const startTime = new Date(props.startDate)
    dt.setHours(startTime.getHours(), startTime.getMinutes())
    return dt
  }

  return (
    <DateTimePicker
      locale="ja"
      selected={selectedDate}
      minTime={createTimePeriod(format(new Date(props.openTime), 'HH:mm'))}
      maxTime={createTimePeriod(format(new Date(props.closeTime), 'HH:mm'))}
      onChange={(date) => selectDate(date)}
      openToDate={new Date().getTime() > new Date(props.startDate).getTime() ? tomorrow() : parseISO(props.startDate)}
      filterDate={isDatePeriod}
      showTimeSelect
      timeIntervals={30}
      timeCaption="時間"
      timeClassName={handleColor}
      isClearable={isClearableFlag}
      customInput={
        <Input inputRef={props.inputRef} idName={props.idName} nameName={props.nameName} className={props.className} />
      }
    />
  )
}

export default DatePicker
